import { render, staticRenderFns } from "./SubTask.vue?vue&type=template&id=ab02091a&scoped=true"
import script from "./SubTask.vue?vue&type=script&lang=js"
export * from "./SubTask.vue?vue&type=script&lang=js"
import style0 from "./SubTask.vue?vue&type=style&index=0&id=ab02091a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab02091a",
  null
  
)

export default component.exports